<template>
  <!--begin::Tiles Widget 22-->
  <div class="card card-custom bgi-no-repeat gutter-b stash-card-1">
    <!--begin::Body-->
    <div class="card-body">
      <p
        class="font-size-lg font-weight-bolder mt-5 infoText"
        v-html="$t('detail.stash.allFileInfo')"
      ></p>
    </div>
    <!--end::Body-->
  </div>
  <!--end::Tiles Widget 22-->
</template>

<script>
export default {
  name: 'StashCard1',
}
</script>

<style scoped lang="scss">
.stash-card-1 {
  height: 250px;
  background-size: 100% auto;
  background-image: url('/media/stash/stash-card-bg.png');
  background-size: cover;
}
@media (max-width: 1200px) {
  .stash-card-1 {
    .infoText {
      font-size: 22px;
    }
  }
}
</style>
